import React from 'react';
import { 
  TrendingUp, 
  Users, 
  Award, 
  Menu, 
  PhoneCall, 
  Clock 
} from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  TrendingUp,
  Users,
  Award,
  Menu,
  PhoneCall,
  Clock
};

const Benefits = () => {
  return (
    <section className="benefits-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title-large">
            Una página web profesional cambia tu negocio
          </h2>
          <p className="section-subtitle">
            Los beneficios de tener presencia digital van más allá de lo visible
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div key={benefit.id} className="benefit-card">
                <div className="benefit-icon-container">
                  <IconComponent className="benefit-icon" size={32} />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
